import { parseDateTime } from "../orders/format";

const sameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const sectionTitleFor = (transaction, now = new Date()) => {
  const parsed = parseDateTime(transaction?.createdAt);

  if (!parsed) return "Earlier";
  if (sameDay(parsed, now)) return "Today";

  const yesterday = new Date(now);

  yesterday.setDate(now.getDate() - 1);

  if (sameDay(parsed, yesterday)) return "Yesterday";

  return transaction?.dateLabel || "Earlier";
};

export const groupTransactions = (items, now = new Date()) => {
  const sections = [];

  (items || []).forEach((transaction) => {
    const title = sectionTitleFor(transaction, now);
    const last = sections[sections.length - 1];

    if (last && last.title === title) last.items.push(transaction);
    else sections.push({ title, items: [transaction] });
  });

  return sections;
};
